import * as React from 'react';

import {Button} from 'shells/button/button';
import {EmptyTimeline} from 'shells/empty-states/empty-timeline';
import {NothingFoundEmptyState} from 'shells/empty-states/nothing-found-empty-state';

import styles from './timeline-empty-state.module.css';

type Props = {
    onRemoveAllFilters?: () => void;
};

export function TimelineEmptyState(props: Props) {
    return (
        <div className={styles['empty-state']}>
            <div className={styles['empty-state-msg']}>
                <NothingFoundEmptyState
                    title='No matching entries'
                    subtitle={
                        <Button
                            variant='text-primary'
                            onClick={props.onRemoveAllFilters}
                            className={styles['no-padding']}
                        >
                            Remove filters
                        </Button>
                    }
                />
            </div>
            <EmptyTimeline />
        </div>
    );
}
